import React from 'react';
import { Box, Grid, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import CommonSDF from "components/commonSDF/CommonSdf";

export default function TabVendor({ 
       onTabChange,
       TableData,
       onClickTable,
       value,
       moreIconData,
       onClickMoreIcon,
       handleChangePage,
       handleChangeRowsPerPage,
       page,
       rowsPerPage,
       onFilterChange,
       onRestFilter,
       filterdata,
       onSearch,
       loaderDriver,
       loaderVehicle,
       loadersubVendor,
       loaderUser, 
       defaultStatus, 
       search}) {
  
  const handleChange = (event, newValue) => {
    onTabChange(newValue);
  };

  const onClickTableVendor = (val) => {
    onClickTable(val);
  };

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle marginTop5"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' },
                  }}
                >
                  <Tab
                    label="Sub-Vendor"
                    value="1"
                    className="tabStyle"
                  />
                  <Tab label="Driver" value="2" className="tabStyle" />
                  <Tab label="Vehicle" value="3" className="tabStyle" />
                  <Tab label="User" value="4" className="tabStyle" />
                </TabList>
              </Grid>
                <Grid item xs={6}>
                  <CommonSDF 
                    onSearch={onSearch} 
                    searchValue={search} 
                    value={value}
                    filterdata={filterdata} 
                    onFilterChange={onFilterChange}
                    onRestFilter={onRestFilter} 
                    defaultStatus={defaultStatus}
                  />
                </Grid>
            </Grid>

            <TabPanel value="1" className='vendotTable tabPanelStyle' sx={{ width: '100%' }}>
              {loadersubVendor ? <Loader/> : ( 
              <CommonTable 
                data={TableData} 
                onClickTableVendor={onClickTableVendor} 
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                moreIconData={moreIconData}
                onClickMoreIcon={onClickMoreIcon}
                isClickable={true}
              /> )}
            </TabPanel>
            <TabPanel value="2" className='vendotTable tabPanelStyle'> 
              {loaderDriver ? <Loader /> : (
              <CommonTable 
                data={TableData} 
                onClickTableVendor={onClickTableVendor}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                moreIconData={moreIconData}
                onClickMoreIcon={onClickMoreIcon}
                isClickable={true}
                tabName={'driver'}
              /> )}
            </TabPanel>
            <TabPanel value="3" className='vendotTable tabPanelStyle'>
              {loaderVehicle ? <Loader /> : (
              <CommonTable 
                data={TableData} 
                onClickTableVendor={onClickTableVendor} 
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                moreIconData={moreIconData}
                onClickMoreIcon={onClickMoreIcon}
                tabName={'vehicle'}
                isClickable={true}
              /> )}
            </TabPanel>
            <TabPanel value="4" className='vendotTable tabPanelStyle'>
              <Typography>
                {loaderUser ? <Loader /> : (  
                <CommonTable 
                  data={TableData} 
                  onClickTableVendor={onClickTableVendor} 
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  moreIconData={moreIconData}
                  onClickMoreIcon={onClickMoreIcon}
                  isClickable={false}
                /> )}
              </Typography>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}